/* eslint-disable */
import React from 'react';
import {Layout} from "antd";
import FormSearch from './components/FormSearch';
import ListInventory from './components/ListInventory';
const {Content} = Layout;

class InventoryHistoryContainer extends React.PureComponent {
    render() {
        return (
            <Layout>
                <Content className="a-content a-content--page-list">
                    <FormSearch/>
                    <ListInventory/>
                </Content>
            </Layout>

        )
    }
}

export default InventoryHistoryContainer;